import React from "react";

import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";
import { CloseIcon } from "../../../../assets/ui/icons";

/* The dialog shell every dialog in this flow shares. */
export const EditDialog = ({
  title,
  onClose,
  children,
  ctaLabel,
  onSubmit,
  submitting = false,
  submitDisabled = false,
  width = 480,
  className = "",
}) => (
  <div
    className={cn(
      /* The design's .pe-modal: 18px and a lifted shadow, shared by every dialog
       on the flow so none of them rounds differently. */
      "u1-root flex max-h-[85vh] flex-col overflow-hidden bg-white text-left",
      "rounded-[var(--radius-modal)] shadow-[shadow:var(--shadow-lg)]",
      className
    )}
    /* One arbitrary value the design varies per dialog; a Tailwind class
       cannot be generated from a prop. */
    style={{ width: `min(92vw, ${width}px)` }}
  >
    <header className="flex shrink-0 items-start justify-between gap-4 px-5 pt-5 sm:px-6">
      <h2 className="m-0 text-[17px] font-bold text-[var(--ink)] font-sans">
        {title}
      </h2>
      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        className={cn(
          "flex h-8 w-8 shrink-0 items-center justify-center rounded-full",
          "bg-[var(--slate-2)] text-[var(--muted)] transition-colors",
          "hover:bg-[var(--line)] focus-visible:outline-none",
          "focus-visible:ring-2 focus-visible:ring-[var(--coral)]"
        )}
      >
        <CloseIcon size={14} />
      </button>
    </header>

    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
      className="flex min-h-0 flex-1 flex-col"
    >
      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4 sm:px-6">
        {children}
      </div>

      {ctaLabel && (
        <div className="shrink-0 px-5 pb-5 sm:px-6">
          <Button
            type="submit"
            variant="coralSolid"
            disabled={submitting || submitDisabled}
            className="w-full"
          >
            {submitting ? "Saving…" : ctaLabel}
          </Button>
        </div>
      )}
    </form>
  </div>
);

export default EditDialog;
